import * as React from 'react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import * as fonts from '@helpcenter/styles/src/fonts';
import type { WrappedComponentProps, MessageDescriptor } from 'react-intl-next';
import { injectIntl } from 'react-intl-next';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { Text } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { UseTypographyMigratedComponent } from '@atlassian/help-center-common-util/enable-typography-migration';

export interface Props {
    errorMessage: string | MessageDescriptor;
}

const ErrorIndication: React.FunctionComponent<Props & WrappedComponentProps> = ({ errorMessage, intl }) => {
    return (
        <UseTypographyMigratedComponent
            migratedComponent={
                <ContainerV2>
                    <StatusErrorIcon label="error" color={token('color.icon.danger', colors.R500)} size="small" />
                    <Text size="small" color="color.text.danger">
                        {typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)}
                    </Text>
                </ContainerV2>
            }
        >
            <Container>
                <StatusErrorIcon label="error" color={token('color.icon.danger', colors.R500)} size="small" />
                {typeof errorMessage === 'string' ? errorMessage : intl.formatMessage(errorMessage)}
            </Container>
        </UseTypographyMigratedComponent>
    );
};

export default injectIntl(ErrorIndication);

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const ContainerV2 = styled.div`
    margin-top: ${token('space.050', '4px')};
    display: flex;
    align-items: center;
    gap: ${token('space.050', '4px')};
`;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
const Container = styled.div`
    ${fonts.small};
    margin-top: ${token('space.050', '4px')};
    color: ${token('color.text.danger', colors.R500)};
    display: flex;
    align-items: center;
    gap: ${token('space.050', '4px')};
`;
